<template>
    <div>
      <div class="foot-top">
        <div class="foot-top-main">
          <div class="foot-top-main-item">
            <i class="foot-top-main-item-icon"><img src="../../../static/img/ts-img/foot-icon1.png" width="30"></i>
            <div class="foot-top-main-item-txt">
              <h3>如实描述承诺</h3>
              <p>卖家会遵守检测服务中的描述承诺</p>
            </div>
          </div>
          <div class="foot-top-main-item">
            <i class="foot-top-main-item-icon"><img src="../../../static/img/ts-img/foot-icon2.png" width="30"></i>
            <div class="foot-top-main-item-txt">
              <h3>中国学术不端正规检测</h3>
              <p>中国学术不端正规论文查重入口</p>
            </div>
          </div>
          <div class="foot-top-main-item">
            <i class="foot-top-main-item-icon"><img src="../../../static/img/ts-img/foot-icon3.png" width="30"></i>
            <div class="foot-top-main-item-txt">
              <h3>安全可信赖</h3>
              <p>卖家已缴纳足额保证金来确保安全</p>
            </div>
          </div>
          <div class="foot-top-main-item">
            <i class="foot-top-main-item-icon"><img src="../../../static/img/ts-img/foot-icon4.png" width="30"></i>
            <div class="foot-top-main-item-txt">
              <h3>售后服务保障</h3>
              <p>中国学术不端论文查重提供全面的售后服务</p>
            </div>
          </div>
        </div>
      </div>
      <div class="foot-center">
        <div class="foot-center-main">
          <h3 class="tips-txt">友情链接:</h3>
          <p class="friend-link">
            <a v-for="(item,index) in footLink" :key="index"  :href="item.url">{{item.name}}</a>
          </p>
          <div class="foot-nav-box">
            <div class="foot-nav">
              <a @click="navLinkFun('/descriptionFirst/',14)">系统简介</a>
              <a @click="navLinkFun('/newsList/')">查重资讯</a>
              <a @click="navLinkFun('/chSystem/')">免费查重</a>
              <a @click="navLinkFun('/reportDownload/')">中国学术不端查重报告下载</a>
              <a>联系我们</a>
            </div>
            <p class="foot-address">地址：{{footInfo.company_address}}</p>
          </div>
        </div>
      </div>
      <div class="foot-bottom">
        <div>
          <p>{{footInfo.copyright}}</p>
          <p>本站声明：{{footInfo.statement}}</p>
          <p>{{copyright_statement}}</p>
        </div>
      </div>
    </div>
</template>

<script>
  import tool from '../../assets/js/tool.js'
  import {
    mapState,
    mapMutations
  } from 'vuex'
    export default {
        name: "foot-bottom",
        data () {
          return {
            footLink: '',
            footInfo: '',
            copyright_statement:'',//版权说明
          }
        },
      computed: {
        ...mapState(['headNavLink'])
      },
        methods: {
          ...mapMutations(['changeHeadNavLink']),
          //友情链接
          footLinkFun () {
              let data = {
                type: 1
              };
              tool.postData('get_bottom',data,(res) => {
                this.footLink = res.data.data.bottom_list;
              });
          },
          //底部信息
          footInfoFun () {
            let data = {};
            tool.postData('get_setting',data,(res) => {
              this.footInfo = res.data.data;
              this.changeHeadNavLink(this.footInfo.free_url);
              this.copyright_statement = res.data.data.copyright_statement
            });
          },
          //链接跳转
          navLinkFun (url,id) {
            this.$router.push({
              path: url,
              query: {
                id:id
              }
            });
            window.scrollTo(0,0);
          },
        },
        mounted () {
          this.footLinkFun();
          this.footInfoFun ();
        }
    }
</script>

<style scoped lang="scss">
  @import "../../assets/style/common";
  .foot-top{
    width: 100%;
    height: 130px;
    background-color: #182b58;
    .foot-top-main{
      width: $box-width;
      height: 130px;
      margin: 0 auto;
      @include flex;
      .foot-top-main-item{
        width: 266px;
        margin-right: 30px;
        @include flex;
        .foot-top-main-item-txt{
          h3{
            @include font(20px,#fff)
          }
          p{
            @include font(14px,#fff);
            line-height: 26px;
          }
        }
      }
    }
  }
  .foot-center{
    width: 100%;
    height: 280px;
    background-color: #131a29;
    .foot-center-main{
      width: $box-width;
      margin: 0 auto;
      padding-top: 13px;
      padding-bottom: 38px;
      box-sizing: border-box;
      .tips-txt{
        @include font(16px,#fff);
        line-height: 36px;
      }
      .friend-link{
        a{
          @include font(16px,#fff);
          line-height: 27px;
          margin-right: 5px;
        }
      }
      .foot-nav-box{
        @include flex;
        margin-top: 50px;
        .foot-nav{
          a{
            padding: 0 21px;
            cursor: pointer;
            @include font(18px,#fff);
            border-left: 1px solid #fff;
            &:first-child{
              border-left: none;
              padding-left: 0;
            }
          }
        }
        .foot-address{
          @include font(18px,#fff);
        }
      }
    }
  }
  .foot-bottom{
    width: 100%;
    height: 100px;
    background-color: #0e131d;
    display: flex;
    align-items: center;
    justify-content: center;
    p{
      @include font(14px,#fff);
      text-align: center;
      line-height: 27px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/foot-bottom.vue